<template>
  <div id="app">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>


export default {
  name: 'app',

  created() {

    let obj=window.location.href.split(window.location.origin)[1];

    if (obj == '/user' && this.$store.state.LoginStatus == false){
      this.$router.push('/login')
    }
    let index = this.contain(this.$store.state.UrlList,obj)

    this.$store.commit('GetCurrentIndex',index)

  },
  mounted(){
    window.addEventListener('beforeunload',ev => {
      this.$router.push(this.router)
    })
    let obj=window.location.href.split(window.location.origin)[1];

    if (obj.indexOf('/user') !== -1 && this.$store.state.LoginStatus == false){
      this.$router.push('/login')
    }
  },
  computed:{
    router(){
      return  window.location.href.split(window.location.origin)[1]
    }
  },
  watch:{
    'this.router'(id){
      // console.log(id);
    }
  },
  methods:{
    contain(array,obj){
      let i = array.length;
      while (i--) {
        if (array[i] === obj) {
          return i;
        }
      }
      return 0;
    },
  }
}
</script>

<style >
:root {
  --main-color: #358ED7;
  --first-text: #333333;
  --second-text: #666666;
  --third-text: #999999;
  --border-color: #dddddd;
  --bg-color: #F6F7F8;
  --first-info: #F98B00;
  --second-info: #E74C3C;
  --third-info: #4F9635
}
*{
  font-family: "思源黑体 CN Regular";
  margin: 0;
  padding: 0;
  cursor: default;
  box-sizing: border-box;
}
#app{
  width: 100%;
  height: 100vh;

}

</style>
